import { logger, setDisableScrolling } from '@/common/utils/common'
import _ from 'lodash'
import constant from '@/common/resources/constant'
import { changeProfileProc } from '@/common/utils/login'
import { parseUrl } from 'query-string'
import cookie from '@/common/utils/cookie'
import { showLoginPopup } from '@/common/utils/player'
import { PLAYER_UPDATE_EVENT, UPDATE_CONTENT_INFO_EVENT } from '@/common/resources/const'

export default {
  data () {
    return {
      isPlayAd: false,
      shareLayout: false,
      downloadLayout: false,
      downloadContentId: '',
      downloadContentType: '',
      ogTitle: '',
      ogUrl: window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search,
      ogDescription: '',
      ogImage: ''
    }
  },
  methods: {
    setMetaData ({ ogTitle, ogDescription, ogImage }) {
      this.ogTitle = ogTitle
      this.ogDescription = ogDescription
      this.ogImage = ogImage
    },
    replaceState (url) {
      this.$router.replace(url)
    },
    openDownloadPopup () {
      if (cookie.getCredential() === 'none') {
        showLoginPopup()
      } else {
        this.downloadLayout = true
        setDisableScrolling(true)
      }
    },
    closeDownloadLayout () {
      this.downloadLayout = false
      setDisableScrolling(false) // 윈도우 스크롤 사용
    },
    // 공유 레이어 팝업 닫기
    openShareLayout () {
      this.shareLayout = true
      setDisableScrolling(true) // 윈도우 스크롤 사용
    },
    closeShareLayout () {
      this.shareLayout = false
      setDisableScrolling(false) // 윈도우 스크롤 사용
    },
    delegateGlobalFunctions () {
      let self = this
      // 회원 가입 페이지 이동
      window.gotoSignup = function () {
        window.location.href = constant.URL_MEMBER_SIGNUP
      }
      // 실명 인증 페이지 이동
      window.gotoAuthorization = function () {
        window.location.href = constant.URL_MEMBER_ME
      }
      // 광고 재생 여부 변경
      window.isPlayAd = function (isPlayAd) {
        self.isPlayAd = isPlayAd
      }
      // 프로필 정보가 바꼈을 때 리로그인 처리
      window.reLoginProc = function () {
        changeProfileProc({ profileId: 0 }).then(() => {
          window.location.reload()
        })
      }
      // 공유 레이어 팝업
      window.showShareLayout = function () {
        self.shareLayout = true
        setDisableScrolling(true) // 윈도우 스크롤 방지
      }
    },
    delegateUpdateEvent () {
      this.$events.$on(PLAYER_UPDATE_EVENT, (info) => {
        const value = _.assign(info, { resetPage: false })
        let current = location.pathname.replace('/player/', '')
        let destination = _.get(value, 'type', '')
        const isVod = type => (type === 'vod' || type === 'onairvod')
        current = isVod(current) ? 'vod' : current
        destination = isVod(destination) ? 'vod' : destination
        logger('red')(current)
        logger('red')(destination)
        // INFO: 같은 화면 (BROADCAST, ONAIR BROADCAST) 일 경우에는 meta 정보, 리스트만 업데이트
        if (current === destination) {
          logger('red')('same')
          if (current === 'vod' && destination === 'vod') {
            const { query } = parseUrl(location.href)
            const existProgramId = _.get(query, 'programid', '')
            const newProgramId = _.get(value, 'programID', '')
            if (existProgramId !== newProgramId) {
              value.resetPage = true
            }
          }
          this.$events.$emit(UPDATE_CONTENT_INFO_EVENT, value)
        } else {
          logger('red')(current)
          logger('red')(destination)
          let url = null
          if (destination === 'vod') {
            url = '/player/vod?contentid=' + value.contentID + '&programid=' + value.programID
          } else if (destination === 'movie') {
            url = '/player/movie?movieid=' + value.contentID
          } else if (destination === 'live') {
            url = '/player/live?channelid=' + value.contentID
          }
          // INFO: CLIP 삭제
          // else if (destination === 'clip') {
          //   url = '/player/clip.html?clipid=' + value.contentID
          // }
          // this.$router.push(url)
          location.href = window.location.protocol + '//' + window.location.hostname + url
        }
      })
    }
  },
  created () {
    this.delegateGlobalFunctions()
    this.delegateUpdateEvent()
  },
  beforeDestroy () {
    this.$events.$off(PLAYER_UPDATE_EVENT)
    this.$events.$off(UPDATE_CONTENT_INFO_EVENT)
  }
}
